
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_xttbq_1i4dh_93"
};
  